import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ReCaptchaService } from '../../../services/recaptcha.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private auth: AuthService,
        private router: Router,
        private title: Title,
        public loading: LoadingService,
        private toastr: ToastrService,
        private reCaptchaService: ReCaptchaService,
        private el: ElementRef) {
        this.route.queryParams
            .subscribe(params => {
                this.showNotification = (params.success == '1');
            });
    }
    showNotification = false;
    loginForm = new FormGroup({
        email: new FormControl(null, Validators.email)
    });
    success = false;

    async submitForm(loginForm: any): Promise<void> {
        if (!loginForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0].focus();
            return;
        }
        this.loading.start();
        loginForm.disable({ emitEvent: false });

        try {

            const fdata = this.loginForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('fe_forgot_password');
            const res: any = await this.auth.forgotPassword({ email: fdata.email, token });

            loginForm.enable({ emitEvent: false });

            if (res.success) {
                this.success = true;
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    loginForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });
                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });

                return;
            }

            const title = res.response?.message || res.response?.description || 'Oops';
            const desc = res.response?.description || 'Error';
            this.toastr.error(desc, title);

        } catch (error) {
            loginForm.enable({ emitEvent: false });
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');
        } finally {
            this.loading.done();
        }
    }

    closeNotification(): void {
        this.router.navigate(['/login']);
    }

    ngOnInit(): void {
        this.title.setTitle('Forgot Password | MFGM');
    }
}


